var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSparkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40757 15.3334C5.33157 15.3334 5.25491 15.3201 5.17957 15.2927C4.89157 15.1881 4.71157 14.9001 4.74491 14.5954L5.25691 9.86675H1.33357C1.08757 9.86675 0.861573 9.73141 0.745573 9.51408C0.629573 9.29675 0.642906 9.03408 0.779573 8.82941L6.03824 0.962747C6.20891 0.707414 6.53157 0.601414 6.82024 0.707414C7.10891 0.81208 7.28824 1.10008 7.25491 1.40475L6.74291 6.13341H10.6669C10.9129 6.13341 11.1389 6.26875 11.2549 6.48608C11.3702 6.70341 11.3576 6.96608 11.2209 7.17075L5.96157 15.0374C5.83557 15.2267 5.62491 15.3334 5.40757 15.3334Z",
    fill: "#00A0F3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkIcon);
export default __webpack_public_path__ + "static/media/SparkIcon.95c57f77.svg";
export { ForwardRef as ReactComponent };